/* istanbul ignore file - better tested visually */

import { Typography } from '@partful/shared/ui/Typography';
import { ReactNode } from 'react';
import styles from './ErrorMessage.module.scss';

type ErrorPageProps = {
  icon: ReactNode;
  title: ReactNode;
  message: ReactNode;
  actions?: ReactNode;
};

export function ErrorMessage({ icon, title, message, actions }: Readonly<ErrorPageProps>) {
  return (
    <div className={styles.message} role="alert">
      <div className={styles.icon}>{icon}</div>
      <div className={styles.body}>
        <Typography as="p" fontWeight={600} color="var(--error)">
          {title}
        </Typography>
        {message}
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  );
}
